import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

const KEY = "flavoria_cookies_v1";

export function CookieNotice() {
  const [dismissed, setDismissed] = useState(() => {
    try { return localStorage.getItem(KEY) === "yes"; } catch { return true; }
  });
  if (dismissed) return null;

  const accept = () => {
    try { localStorage.setItem(KEY, "yes"); } catch {}
    setDismissed(true);
  };

  return (
    <div data-testid="cookie-notice"
      className="fixed bottom-0 inset-x-0 sm:bottom-3 sm:inset-x-3 sm:left-4 sm:right-auto sm:max-w-sm z-[110] bg-ink text-white shadow-lift border-t sm:border border-white/10 sm:rounded-2xl">
      <div className="flex items-center gap-3 p-3 sm:p-4">
        <Cookie size={18} className="text-gold shrink-0" aria-hidden />
        <p className="text-xs sm:text-sm leading-snug text-white/85 flex-1 min-w-0">
          We use cookies for ads & affiliate links (Google AdSense and partners). See our{" "}
          <Link to="/disclaimer" data-testid="cookie-disclaimer-link" className="font-bold text-coral underline">Disclaimer</Link>.
        </p>
        <button onClick={accept} data-testid="cookie-accept-button"
          className="h-11 px-5 rounded-full bg-coral hover:bg-coral-hover text-white text-sm font-bold transition-colors shrink-0">
          Got it
        </button>
      </div>
    </div>
  );
}
